import {FieldType} from "../../manager/FieldType";
import {FieldTypeManager} from "../../manager";
import {toolbox} from "./toolbox";
import {attributeGroups} from "./attributeGroups";
import {Image} from './Image';

export const imageFieldType: FieldType = {
  name: 'image',
  component: Image,
  attributeGroups,
  toolbox,
};

FieldTypeManager.register(imageFieldType.name, imageFieldType);
